import { render, staticRenderFns } from "./openBacoTime.vue?vue&type=template&id=635b6762&"
import script from "./openBacoTime.vue?vue&type=script&lang=js&"
export * from "./openBacoTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports